import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class RemoveIdentityProviderRequest extends Request<{}, ISiteSAMLConfiguration> {
  constructor() {
    super('removeIdentityProvider', {});
  }
}
